import { computed } from "vue";
import { currentPrinters } from "./getPrinters";
import { isAbleToPlayAudio } from "./playAudio";
import { isMyStoresLoading, myStores } from "./MyStoresStore";
import { storeNotifierChannels } from "./listenStoreNotifier";


export const hasError = computed(() => {
    if (isMyStoresLoading.value) {
        return false
    } else {
        // no printer detected
        return currentPrinters.value.length === 0 ||
            // unable to play audio
            !isAbleToPlayAudio.value ||
            // no store detected
            myStores.value.length === 0 ||
            // no store enabled // no store listening
            (myStores.value.length > 0 && Object.keys(storeNotifierChannels.value).length === 0) ||
            // connection error
            (myStores.value.length > 0 && Object.keys(storeNotifierChannels.value).length === 0);
    }
});

